import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.58 7.69" {...props}><path className={styles["cls-1"] || "cls-1"} fill="transparent" d="M.5 4.28l3.68 2.91L10.08.5" /></svg>;